import { create } from 'zustand';
import { IActiveItem } from '../models/modules';
import { persist } from 'zustand/middleware';
import { IModules } from '../../../core/models/disciplines';

interface ModuleState {
  modules: IModules[] | null;
  moduleSlug: string | null;
  active: IActiveItem | null;
  isLoading: boolean;
  _hasHydrated: boolean | null;
  setModuleSlug: (slug: string) => void;
  setActive: (discipline: IActiveItem | null) => void;
  setModules: (modules: IModules[]) => void;
  setIsLoading: (loading: boolean) => void;
  setHasHydrated: (hydrate: boolean) => void;
  resetModule: () => void;
}

export const useModuleStore = create<ModuleState>()(
  persist(
    (set) => ({
      modules: null,
      moduleSlug: null,
      active: null,
      isLoading: false,
      _hasHydrated: false,
      setActive: (discipline: IActiveItem | null) => set({ active: discipline }),
      setModules: (modules: IModules[]) => set({ modules: modules }),
      setModuleSlug: (slug: string) => set({ moduleSlug: slug }),
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setHasHydrated: (hydrate: boolean) => set({_hasHydrated: hydrate}),
      resetModule: () => set({ modules: null, active: null, isLoading: false, moduleSlug: null })
    }),
    {
      name: 'discipline-module',
      onRehydrateStorage: () => (state) => {
        state && state.setHasHydrated(true)
      }
    }
  )
);